import { Vue, Component } from 'vue-property-decorator';
import {accessor, bridge} from '@/modules/widget-yard/store';
import draggable from 'vuedraggable';
import { Ax } from '@/utils';
import { exporting } from './export-widget';
import { TWidgetLoadState } from '@/modules/widget-yard/store/types';
import VueElementLoading from 'vue-element-loading';

import store from '@/services/store';

import VWidget from '@/modules/widget-yard/c-widget/v-widget';



interface ISection {
    id: number;
    name: string;
    widgets: any;
    children: any;
}

type InfoFile = {
    id: number;
    name: string;
};

@Component({
    components: {
        'v-widget': VWidget,
        'draggable': draggable,
        'loading': VueElementLoading
    }
})
export default class SocMod extends Vue {
    public sectionData: any = {};
    public sectionChild: any = {};
    public curSection: any = {};
    public selectedId = 0;
    private selectedChild: any = {};
    private selectedPostChild: any = {};

    private exportWidgets: any[] = [];

    private allWidgets: any = [];

    private filteredPeriod = 'год';

    private periodicityFilter: Set<string> = new Set();
    private periodicityFilterArray: any[] = [];

    private subSubSectionOptions: any[] = [];

    private currentDescrFiles: InfoFile[] = [
        {
            id: 15,
            name: 'Методика_СЭМ'
        },
        {
            id: 16,
            name: 'РП_СЭМ'
        }
    ];


    private clearChildren() {
        this.sectionChild = {};
        this.selectedChild = {};
        this.selectedPostChild = {};
    }

    private clearChild() {
        this.sectionChild = {};
    }

    public mounted() {
        bridge.loadInitialPub();
    }

    public async created() {
        this.periodicityFilterArray = [];
        await this.getCategory();
        // this.getWidgets();
        // console.log(this.menuSocEcos);


        this.refreshPage();


        let isRenderSelectPostChild = false;
        this.periodicityFilterArray = [...this.periodicityFilter];


        // eslint-disable-next-line @typescript-eslint/no-this-alias
        this.$watch('selectedChild', () => {
            this.subSubSectionOptions = [];

            if (this.sectionData.postChildren && this.selectedChild) {
                this.sectionData.postChildren.forEach((el: any) => {
                    if (el.parent === this.selectedChild.id) {
                        this.subSubSectionOptions.push(el);
                    }
                });
            }

            if (this.selectedChild !== null && Object.keys(this.selectedChild).length > 0) {
                this.sectionData.children.forEach((el: any) => {
                    if (el.parent === this.selectedChild.id) {
                        this.subSubSectionOptions.push(el);
                    }
                });
                this.selectedChild.widgets.sort((a: any, b: any) => a.dictCategoryEntity.index - b.dictCategoryEntity.index);
                const children: any[] = [];
                if (this.selectedChild.children.length > 0) {
                    this.selectedChild.children.forEach((child: any) => {
                        if (child.widgets.length > 0) {
                            children.push(child);
                        }
                    });
                }
                if (children.length > 0) {
                    this.sectionChild = {
                        name: this.selectedChild.name_ru,
                        id: this.selectedChild.id,
                        widgets: this.selectedChild.widgets,
                        children: children
                    };
                    this.getPeriodicityFilter(this.sectionChild);
                    this.filteredPeriod = Array.from(this.periodicityFilter)[0];
                    this.selectedPostChild = {};
                } else {
                    this.sectionChild = {
                        name: this.selectedChild.name_ru,
                        id: this.selectedChild.id,
                        widgets: this.selectedChild.widgets
                    };
                    this.getPeriodicityFilter(this.sectionChild);
                    this.filteredPeriod = Array.from(this.periodicityFilter)[0];
                }
            } else {
                for (const s of this.menuSocMods) {
                    if (s.id === Number(this.$route.query.id)) {
                        isRenderSelectPostChild = false;
                        this.getPeriodicityFilter(s);
                        this.filteredPeriod = Array.from(this.periodicityFilter)[0];
                    }
                }
                this.clearChild();
            }
        });

        this.$watch('selectedPostChild', () => {
            if (this.selectedPostChild && Object.keys(this.selectedPostChild).length > 0) {
                this.sectionChild = {
                    name: this.selectedPostChild.name_ru,
                    id: this.selectedPostChild.id,
                    widgets: this.selectedPostChild.widgets,
                    children: []
                };
                if (this.sectionChild.widgets && this.sectionChild.widgets.length > 0) {
                    isRenderSelectPostChild = true;
                    this.getPeriodicityFilter(this.sectionChild);
                    this.filteredPeriod = Array.from(this.periodicityFilter)[0];

                    this.sectionChild.widgets.sort((a: any, b: any) => a.dictCategoryEntity.index - b.dictCategoryEntity.index);
                }
            } else {
                this.sectionChild = this.selectedChild;
                if (isRenderSelectPostChild) {
                    // console.log("Else select postchild");
                    this.getPeriodicityFilter(this.sectionChild);
                    this.filteredPeriod = Array.from(this.periodicityFilter)[0];
                }
            }
        });
        this.$watch('selectedId', this.clearChildren);

        this.$watch('$route', () => {
            this.periodicityFilterArray = [];
            this.clearChild();
            this.clearChildren();

            this.refreshPage();
            this.periodicityFilterArray = [...this.periodicityFilter];
        });
    }

    private refreshPage() {
        this.curSection.id = Number(this.$route.query.id);
        for (const s of this.menuSocMods) {
            if (s.id === this.curSection.id) {
                // console.log("this is a route")
                this.sectionData = s;
                this.getPeriodicityFilter(s);
                this.filteredPeriod = Array.from(this.periodicityFilter)[0];
                this.selectedId = this.curSection.id;
            }
        }
    }

    private infoCostForm(arrInfoFiles: InfoFile[] = this.currentDescrFiles) {
        arrInfoFiles.forEach((file: InfoFile) => {
            Ax<Blob>(
                {
                    url: '/api-py/get-info/' + file.id, //  Тело файла
                    method: 'POST',
                    data: null,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const titleOfFile = file.name;
                    link.setAttribute('download', titleOfFile + '.pdf');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                }
            );
        });
    }

    public onSelectSection(data: any) {
        this.curSection = data;
    }


    public get isAuthorized(): boolean {
        return store.state.user.authorized;
    }

    private menuSocMods: any[] = [];

    /**
     * Возвращает копию массива без дублей по полю id (сохраняет порядок первого вхождения).
     * Нужна, т.к. API /api/dict/integration_category и /api/datas/hierarchy могут отдавать
     * повторяющиеся записи, которые иначе накапливаются при мердже дерева категорий/виджетов
     * и приводят к дублирующимся Vue key (см. draggable v-for в soc-mod@.vue).
     */
    private uniqueById(arr: any[]): any[] {
        const seenIds = new Set<any>();
        return arr.filter((item: any) => {
            if (seenIds.has(item.id)) {
                return false;
            }
            seenIds.add(item.id);
            return true;
        });
    }

    private async getCategory() {
        let lists: any[] = [];
        const category: any[] = [];
        await fetch('/api/dict/integration_category')
            .then(response => response.json())
            .then(json => (lists = json));
        lists.sort((a: any, b: any) => a.code.split('.').length - b.code.split('.').length);
        for (const list of lists) {
            list.code = list.code.replace(' \t', '');
            if (list.code.split('.')[0] === '02') {
                list.children = [];
                if (list.parent !== null) {
                    lists.forEach((categ: any) => {
                        if (categ.children !== undefined) {
                            if (categ.id === list.parent) {
                                const alreadyLinked = categ.children.some((c: any) => c.id === list.id);
                                if (!alreadyLinked) {
                                    categ.children.push(list);
                                }
                            }
                        }
                    });
                }
            }
            if (list.id === 231) {
                category.push(list);
            }
        }
        const widgets = this.getWidgets();
        for (const list of lists) {
            list.code = list.code.replace(' \t', '');
            if (list.code.split('.')[0] === '02') {
                list.widgets = [];
                // eslint-disable-next-line no-await-in-loop
                for (const widget of await widgets) {
                    if ((widget.dictCategoryEntity !== undefined) && (widget.dictCategoryEntity !== null) && (widget.indicatorConfigs.length > 0)) {
                        if (widget.dictCategoryEntity.index === undefined) {
                            widget.dictCategoryEntity.index = widget.id;
                        }
                        if (list.id === widget.dictCategoryEntity.id && !list.widgets.some((w: any) => w.id === widget.id)) {
                            list.widgets.push(widget);
                        }
                    }
                }
            }
        }
        category[0].children.forEach((list: any) => {
            if (list.children.length > 0) {
                for (const child of list.children) {
                    if (child.children.length > 0) {
                        for (const childish of child.children) {
                            if (childish.widgets.length > 0) {
                                childish.widgets.forEach((widget: any) => {
                                    if (widget.indicatorConfigs.length > 0 && !child.widgets.some((w: any) => w.id === widget.id)) {
                                        child.widgets.push(widget);
                                    }
                                });
                            }
                        }
                    }
                    if (child.widgets.length > 0) {
                        child.widgets.forEach((widget: any) => {
                            if (widget.indicatorConfigs.length > 0 && !list.widgets.some((w: any) => w.id === widget.id)) {
                                list.widgets.push(widget);
                            }
                        });
                    }
                }
            }
            const children: any[] = [];
            const postChildren: any[] = [];
            if (list.children.length > 0) {
                list.children.forEach((child: any) => {
                    // дополнительная защита от дублей на будущее, если данные с бэка придут с повторами
                    child.widgets = this.uniqueById(child.widgets);
                    if (child.widgets.length > 0) {
                        children.push(child);
                        if (child.children.length > 0) {
                            child.children.forEach((childish: any) => {
                                childish.widgets = this.uniqueById(childish.widgets);
                                if (childish.widgets.length > 0) {
                                    postChildren.push(childish);
                                }
                            });
                        }
                    }
                });
            }
            // дополнительная защита от дублей на будущее, если данные с бэка придут с повторами
            list.widgets = this.uniqueById(list.widgets);
            if (list.widgets.length > 0) {
                list.widgets.sort((a: any, b: any) => a.dictCategoryEntity.index - b.dictCategoryEntity.index);
                if (children.length > 0) {
                    if (postChildren.length > 0) {
                        this.menuSocMods.push({
                            name: list.name_ru,
                            id: list.id,
                            code: list.code,
                            widgets: list.widgets,
                            children: children,
                            postChildren: postChildren
                        });
                    } else {
                        this.menuSocMods.push({
                            name: list.name_ru,
                            id: list.id,
                            code: list.code,
                            widgets: list.widgets,
                            children: children
                        });
                    }
                } else {
                    this.menuSocMods.push({
                        name: list.name_ru,
                        id: list.id,
                        code: list.code,
                        widgets: list.widgets
                    });
                }
            }
        });
        this.menuSocMods.forEach((item: any) => {
            const itemes = {
                'code': item.code,
                'name': item.name,
                'widgets': item.widgets,
                'chart': []
            };
            this.exportWidgets.push(itemes);
        });
        this.exportWidgets.sort((a: any, b: any) => parseInt(a.code.split('.')[1]) - parseInt(b.code.split('.')[1]));
        this.exportWidgets.shift();
    }

    private get indexes() {
        const arr = [];
        const list: any = this.sectionData;
        if (list.widgets !== undefined) {
            for (let i = 0; i < list.widgets.length; i++) {
                arr.push(i);
            }
        }
        return arr;
    }

    private get widgetsPos() {
        const arr: any[] = [];
        const list: any = this.sectionData;
        if (list.widgets !== undefined) {
            list.widgets.forEach((widget: any) => {
                arr.push(widget);
            });
        }
        return arr;
    }

    private set widgetsPos(val: any) {
        // const list: any = this.sectionData;
        const list: any = this.sectionData;
        val.forEach((item: any, index: number) => {
            item.dictCategoryEntity.index = this.indexes[index];
        });
        list.widgets = val;
        this.sectionData = list;
        this.saveWidgets();
    }

    private saveWidgets() {
        const list: any = this.sectionData;
        list.widgets.forEach((widget: any) => {
            const index = this.allWidgets.findIndex((i: { id: any}) => i.id === widget.id);
            if (index !== -1) {
                this.allWidgets[index] = widget;
            }
        });
        accessor.widgets = this.allWidgets;
        accessor.saveWidgets();
    }

    private async getWidgets() {
        let lists: any[] = [];
        await fetch('/api/datas/hierarchy')
            .then(response => response.json())
            .then(json => (lists = json));
        this.allWidgets = lists;
        return lists;
    }

    private get widgetsPosChild() {
        const arr: any[] = [];
        if (this.selectedChild) {
            const list: any = this.sectionChild;
            if (list.widgets !== undefined) {
                list.widgets.forEach((widget: any) => {
                    arr.push(widget);
                });
            }
        }
        return arr;
    }

    private set widgetsPosChild(val: any) {
        // const list: any = this.sectionData;
        const list: any = this.sectionChild;
        val.forEach((item: any, index: number) => {
            item.dictCategoryEntity.index = this.indexes[index];
        });
        list.widgets = val;
        this.sectionData = list;
        this.saveWidgetsChild();
    }

    private saveWidgetsChild() {
        const list: any = this.sectionChild;
        list.widgets.forEach((widget: any) => {
            const index = this.allWidgets.findIndex((i: { id: any}) => i.id === widget.id);
            if (index !== -1) {
                this.allWidgets[index] = widget;
            }
        });
        accessor.widgets = this.allWidgets;
        accessor.saveWidgets();
    }

    private exportDone = false;


    private loading = false;

    private clickDownload(dev: string) {
        this.loading = true;
        this.getExport();
        this.getExportMonth();
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        setTimeout(function () {
            const form = {
                'source': that.$store.state._instanceCode,
                'widgets': that.exportWidgets,
                'dev': dev,
                'module': 'sem'
            };
            that.sendToReport(form);
            that.exportDone = true;
        }, 500);
    }

    private getExport() {
        if (!this.exportDone) {
            for (const category of this.exportWidgets) {
                // eslint-disable-next-line consistent-return
                category.widgets.forEach((item: any) => {
                    if (item.indicatorConfigs[0].periodicity.split(' ')[0] !== 'месяц') {
                        const data = exporting.result(item);
                        const chart = exporting.setOptions(data);
                        if (chart === null) {
                            return null;
                        }
                        category.chart.push(chart);
                    }
                });
            }
        }
    }

    private getExportMonth() {
        if (!this.exportDone) {
            for (const category of this.exportWidgets) {
                // eslint-disable-next-line consistent-return
                category.widgets.forEach((item: any) => {
                    if (item.indicatorConfigs[0].periodicity.split(' ')[0] === 'месяц') {
                        const data = exporting.result(item);
                        const chart = exporting.setOptionsMonth(data);
                        if (chart === null) {
                            return null;
                        }
                        category.chart.push(chart);
                    }
                });
            }
        }
    }

    private sendToReport(config: any) {
        // eslint-disable-next-line no-console
        console.log(config);
        Ax(
            {
                url: '/api-py/widget-export',
                method: 'POST',
                data: config
            },
            (data: any) => {
                // eslint-disable-next-line no-console
                console.log(data);
                this.downloadReport(data);
                this.loading = false;
            },
            (error: any) => {
                // eslint-disable-next-line no-console
                console.log(error);
                this.loading = false;
                // eslint-disable-next-line no-alert
                alert('Пожалуйста, обновите страницу и попробуйте снова');
            }
        );
    }

    private downloadReport(url: any) {
        if (url === 'Something went wrong') {
            return;
        }
        window.open('/api-py/widget-export/' + url, '_blank');
    }

    private get widgetsLoadState(): TWidgetLoadState {
        return accessor.widgetsLoadState;
    }
    private getPeriodicityFilter(periodicity: object | any) {
        // console.log(periodicity)
        // let i = 0;
        this.periodicityFilter = new Set<string>();
        let samplePeriodicity = ['год', 'квартал', 'месяц', 'неделя', 'ежедневная'];
        const result: string[] = ['год', 'квартал', 'месяц', 'неделя', 'ежедневная'];


        periodicity.widgets.forEach((widget: any) => {
            widget.indicatorConfigs.forEach((indicator: any) => {
                if (indicator.periodicity) {
                    this.periodicityFilter.add(indicator.periodicity.split(' ')[0]);
                }
            });
        });

        samplePeriodicity.forEach((item) => {
            if (!this.periodicityFilter.has(item)) {
                result.splice(samplePeriodicity.indexOf(item), 1, 'none');
            }
        });

        const finalResult: string[] = [];
        result.forEach((el) => {
            if (el !== 'none') {
                finalResult.push(el);
            }
        });
        this.periodicityFilter = new Set<string>(finalResult);
        samplePeriodicity = [];
    }
}